module.exports = __webpack_public_path__ + "static/assets/2c0f9eeaaf139c53bd359e31d027b4ba.svg";